/** Auto-generated catalog of bundled Serum-format wavetable files. */
import type { WavetableCatalogEntry } from "./types";

export const WAVETABLE_FILE_CATALOG: readonly WavetableCatalogEntry[] = [
  {
    id: "krc/krc-poly-explore-16-1-free",
    name: "KRC Poly Explore 16 1 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Poly Explore 16 1 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-poly-explore-16-10-free",
    name: "KRC Poly Explore 16 10 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Poly Explore 16 10 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-poly-explore-16-11-free",
    name: "KRC Poly Explore 16 11 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Poly Explore 16 11 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-poly-explore-16-12-free",
    name: "KRC Poly Explore 16 12 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Poly Explore 16 12 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-poly-explore-16-13-free",
    name: "KRC Poly Explore 16 13 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Poly Explore 16 13 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-poly-explore-16-14-free",
    name: "KRC Poly Explore 16 14 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Poly Explore 16 14 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-poly-explore-16-15-free",
    name: "KRC Poly Explore 16 15 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Poly Explore 16 15 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-poly-explore-16-16-free",
    name: "KRC Poly Explore 16 16 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Poly Explore 16 16 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-poly-explore-16-2-free",
    name: "KRC Poly Explore 16 2 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Poly Explore 16 2 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-poly-explore-16-3-free",
    name: "KRC Poly Explore 16 3 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Poly Explore 16 3 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-poly-explore-16-4-free",
    name: "KRC Poly Explore 16 4 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Poly Explore 16 4 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-poly-explore-16-5-free",
    name: "KRC Poly Explore 16 5 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Poly Explore 16 5 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-poly-explore-16-6-free",
    name: "KRC Poly Explore 16 6 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Poly Explore 16 6 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-poly-explore-16-7-free",
    name: "KRC Poly Explore 16 7 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Poly Explore 16 7 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-poly-explore-16-8-free",
    name: "KRC Poly Explore 16 8 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Poly Explore 16 8 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-poly-explore-16-9-free",
    name: "KRC Poly Explore 16 9 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Poly Explore 16 9 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-rand-explore-1-free",
    name: "KRC Rand Explore 1 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Rand Explore 1 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-rand-explore-16-1-free",
    name: "KRC Rand Explore 16 1 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Rand Explore 16 1 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-rand-explore-16-2-free",
    name: "KRC Rand Explore 16 2 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Rand Explore 16 2 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-rand-explore-16-3-free",
    name: "KRC Rand Explore 16 3 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Rand Explore 16 3 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-rand-explore-16-4-free",
    name: "KRC Rand Explore 16 4 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Rand Explore 16 4 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-rand-explore-16-5-free",
    name: "KRC Rand Explore 16 5 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Rand Explore 16 5 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-rand-explore-16-6-free",
    name: "KRC Rand Explore 16 6 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Rand Explore 16 6 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-rand-explore-16-7-free",
    name: "KRC Rand Explore 16 7 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Rand Explore 16 7 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-rand-explore-16-8-free",
    name: "KRC Rand Explore 16 8 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Rand Explore 16 8 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-rand-explore-2-free",
    name: "KRC Rand Explore 2 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Rand Explore 2 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-rand-explore-3-free",
    name: "KRC Rand Explore 3 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Rand Explore 3 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-rand-explore-4-free",
    name: "KRC Rand Explore 4 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Rand Explore 4 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-rand-explore-5-free",
    name: "KRC Rand Explore 5 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Rand Explore 5 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-rand-explore-6-free",
    name: "KRC Rand Explore 6 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Rand Explore 6 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-rand-explore-7-free",
    name: "KRC Rand Explore 7 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Rand Explore 7 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-rand-explore-8-free",
    name: "KRC Rand Explore 8 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Rand Explore 8 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-random-explore-64-1-free",
    name: "KRC Random Explore 64 1 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Random Explore 64 1 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-random-explore-64-2-free",
    name: "KRC Random Explore 64 2 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Random Explore 64 2 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-random-explore-64-3-free",
    name: "KRC Random Explore 64 3 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Random Explore 64 3 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-random-explore-64-4-free",
    name: "KRC Random Explore 64 4 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Random Explore 64 4 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-random-explore-64-5-free",
    name: "KRC Random Explore 64 5 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Random Explore 64 5 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/krc-random-explore-64-6-free",
    name: "KRC Random Explore 64 6 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/KRC Random Explore 64 6 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00001-free",
    name: "RAIM 00001 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00001 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00004-free",
    name: "RAIM 00004 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00004 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00012-free",
    name: "RAIM 00012 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00012 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00013-free",
    name: "RAIM 00013 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00013 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00016-free",
    name: "RAIM 00016 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00016 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00022-free",
    name: "RAIM 00022 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00022 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00031-free",
    name: "RAIM 00031 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00031 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00032-free",
    name: "RAIM 00032 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00032 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00034-free",
    name: "RAIM 00034 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00034 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00037-free",
    name: "RAIM 00037 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00037 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00038-free",
    name: "RAIM 00038 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00038 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00040-free",
    name: "RAIM 00040 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00040 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00045-free",
    name: "RAIM 00045 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00045 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00058-free",
    name: "RAIM 00058 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00058 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00064-free",
    name: "RAIM 00064 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00064 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00072-free",
    name: "RAIM 00072 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00072 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00075-free",
    name: "RAIM 00075 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00075 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00077-free",
    name: "RAIM 00077 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00077 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00078-free",
    name: "RAIM 00078 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00078 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00080-free",
    name: "RAIM 00080 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00080 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00081-free",
    name: "RAIM 00081 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00081 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00082-free",
    name: "RAIM 00082 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00082 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00084-free",
    name: "RAIM 00084 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00084 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00089-free",
    name: "RAIM 00089 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00089 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00102-free",
    name: "RAIM 00102 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00102 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00104-free",
    name: "RAIM 00104 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00104 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00110-free",
    name: "RAIM 00110 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00110 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00116-free",
    name: "RAIM 00116 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00116 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00120-free",
    name: "RAIM 00120 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00120 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00129-free",
    name: "RAIM 00129 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00129 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00130-free",
    name: "RAIM 00130 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00130 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00135-free",
    name: "RAIM 00135 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00135 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00144-free",
    name: "RAIM 00144 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00144 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00145-free",
    name: "RAIM 00145 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00145 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00154-free",
    name: "RAIM 00154 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00154 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00155-free",
    name: "RAIM 00155 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00155 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00184-free",
    name: "RAIM 00184 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00184 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00188-free",
    name: "RAIM 00188 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00188 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00197-free",
    name: "RAIM 00197 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00197 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00215-free",
    name: "RAIM 00215 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00215 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00219-free",
    name: "RAIM 00219 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00219 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00245-free",
    name: "RAIM 00245 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00245 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00253-free",
    name: "RAIM 00253 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00253 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00255-free",
    name: "RAIM 00255 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00255 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00263-free",
    name: "RAIM 00263 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00263 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00264-free",
    name: "RAIM 00264 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00264 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00269-free",
    name: "RAIM 00269 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00269 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00279-free",
    name: "RAIM 00279 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00279 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00286-free",
    name: "RAIM 00286 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00286 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00290-free",
    name: "RAIM 00290 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00290 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00291-free",
    name: "RAIM 00291 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00291 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00300-free",
    name: "RAIM 00300 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00300 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00310-free",
    name: "RAIM 00310 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00310 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00317-free",
    name: "RAIM 00317 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00317 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00350-free",
    name: "RAIM 00350 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00350 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00357-free",
    name: "RAIM 00357 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00357 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/raim-00378-free",
    name: "RAIM 00378 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/RAIM 00378 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/v2-mband-interp-1-free",
    name: "V2 Mband Interp 1 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/V2 Mband Interp 1 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/v2-mband-interp-10-free",
    name: "V2 Mband Interp 10 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/V2 Mband Interp 10 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/v2-mband-interp-11-free",
    name: "V2 Mband Interp 11 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/V2 Mband Interp 11 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/v2-mband-interp-12-free",
    name: "V2 Mband Interp 12 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/V2 Mband Interp 12 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/v2-mband-interp-13-free",
    name: "V2 Mband Interp 13 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/V2 Mband Interp 13 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/v2-mband-interp-14-free",
    name: "V2 Mband Interp 14 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/V2 Mband Interp 14 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/v2-mband-interp-15-free",
    name: "V2 Mband Interp 15 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/V2 Mband Interp 15 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/v2-mband-interp-16-free",
    name: "V2 Mband Interp 16 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/V2 Mband Interp 16 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/v2-mband-interp-2-free",
    name: "V2 Mband Interp 2 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/V2 Mband Interp 2 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/v2-mband-interp-3-free",
    name: "V2 Mband Interp 3 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/V2 Mband Interp 3 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/v2-mband-interp-4-free",
    name: "V2 Mband Interp 4 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/V2 Mband Interp 4 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/v2-mband-interp-5-free",
    name: "V2 Mband Interp 5 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/V2 Mband Interp 5 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/v2-mband-interp-6-free",
    name: "V2 Mband Interp 6 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/V2 Mband Interp 6 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/v2-mband-interp-7-free",
    name: "V2 Mband Interp 7 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/V2 Mband Interp 7 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/v2-mband-interp-8-free",
    name: "V2 Mband Interp 8 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/V2 Mband Interp 8 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/v2-mband-interp-9-free",
    name: "V2 Mband Interp 9 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/V2 Mband Interp 9 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/vol-1-mband-1-free",
    name: "Vol 1 Mband 1 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/Vol 1 Mband 1 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/vol-1-mband-10-free",
    name: "Vol 1 Mband 10 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/Vol 1 Mband 10 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/vol-1-mband-11-free",
    name: "Vol 1 Mband 11 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/Vol 1 Mband 11 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/vol-1-mband-12-free",
    name: "Vol 1 Mband 12 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/Vol 1 Mband 12 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/vol-1-mband-13-free",
    name: "Vol 1 Mband 13 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/Vol 1 Mband 13 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/vol-1-mband-14-free",
    name: "Vol 1 Mband 14 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/Vol 1 Mband 14 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/vol-1-mband-15-free",
    name: "Vol 1 Mband 15 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/Vol 1 Mband 15 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/vol-1-mband-16-free",
    name: "Vol 1 Mband 16 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/Vol 1 Mband 16 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/vol-1-mband-2-free",
    name: "Vol 1 Mband 2 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/Vol 1 Mband 2 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/vol-1-mband-3-free",
    name: "Vol 1 Mband 3 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/Vol 1 Mband 3 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/vol-1-mband-4-free",
    name: "Vol 1 Mband 4 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/Vol 1 Mband 4 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/vol-1-mband-5-free",
    name: "Vol 1 Mband 5 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/Vol 1 Mband 5 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/vol-1-mband-6-free",
    name: "Vol 1 Mband 6 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/Vol 1 Mband 6 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/vol-1-mband-7-free",
    name: "Vol 1 Mband 7 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/Vol 1 Mband 7 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/vol-1-mband-8-free",
    name: "Vol 1 Mband 8 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/Vol 1 Mband 8 Free.wav",
    group: "KRC",
  },
  {
    id: "krc/vol-1-mband-9-free",
    name: "Vol 1 Mband 9 Free",
    source: "file",
    pack: "krc",
    path: "wavetables/KRC Sampler Free Pack/Vol 1 Mband 9 Free.wav",
    group: "KRC",
  },
  {
    id: "bvker/analog/analog-pwm-custom-01",
    name: "Analog PWM Custom 01",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 01.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-custom-02",
    name: "Analog PWM Custom 02",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 02.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-custom-03",
    name: "Analog PWM Custom 03",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 03.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-custom-04",
    name: "Analog PWM Custom 04",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 04.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-custom-05",
    name: "Analog PWM Custom 05",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 05.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-custom-06",
    name: "Analog PWM Custom 06",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 06.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-custom-07",
    name: "Analog PWM Custom 07",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 07.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-custom-08",
    name: "Analog PWM Custom 08",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 08.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-custom-09",
    name: "Analog PWM Custom 09",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 09.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-custom-10",
    name: "Analog PWM Custom 10",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 10.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-custom-11",
    name: "Analog PWM Custom 11",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 11.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-custom-12",
    name: "Analog PWM Custom 12",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 12.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-custom-13",
    name: "Analog PWM Custom 13",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 13.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-custom-14",
    name: "Analog PWM Custom 14",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 14.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-custom-15",
    name: "Analog PWM Custom 15",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 15.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-custom-16",
    name: "Analog PWM Custom 16",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 16.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-custom-17",
    name: "Analog PWM Custom 17",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 17.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-custom-18",
    name: "Analog PWM Custom 18",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 18.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-custom-19",
    name: "Analog PWM Custom 19",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 19.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-custom-20",
    name: "Analog PWM Custom 20",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Custom 20.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-saw-01",
    name: "Analog PWM Saw 01",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Saw 01.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-saw-02",
    name: "Analog PWM Saw 02",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Saw 02.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-saw-03",
    name: "Analog PWM Saw 03",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Saw 03.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-saw-04",
    name: "Analog PWM Saw 04",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Saw 04.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-saw-05",
    name: "Analog PWM Saw 05",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Saw 05.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-saw-06",
    name: "Analog PWM Saw 06",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Saw 06.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-saw-07",
    name: "Analog PWM Saw 07",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Saw 07.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-square-01",
    name: "Analog PWM Square 01",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Square 01.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-square-02",
    name: "Analog PWM Square 02",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Square 02.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-square-03",
    name: "Analog PWM Square 03",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Square 03.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-square-04",
    name: "Analog PWM Square 04",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Square 04.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-square-05",
    name: "Analog PWM Square 05",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Square 05.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-square-06",
    name: "Analog PWM Square 06",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Square 06.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-sub-01",
    name: "Analog PWM Sub 01",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Sub 01.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-sub-02",
    name: "Analog PWM Sub 02",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Sub 02.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-sub-03",
    name: "Analog PWM Sub 03",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Sub 03.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-sub-04",
    name: "Analog PWM Sub 04",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Sub 04.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-sub-05",
    name: "Analog PWM Sub 05",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Sub 05.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-sub-06",
    name: "Analog PWM Sub 06",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Sub 06.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-sub-07",
    name: "Analog PWM Sub 07",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Sub 07.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/analog/analog-pwm-sub-08",
    name: "Analog PWM Sub 08",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Analog/Analog PWM Sub 08.wav",
    group: "BVKER / Analog",
  },
  {
    id: "bvker/distorted/dist-asym",
    name: "Dist - Asym",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Distorted/Dist - Asym.wav",
    group: "BVKER / Distorted",
  },
  {
    id: "bvker/distorted/dist-diode-1",
    name: "Dist - Diode 1",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Distorted/Dist - Diode 1.wav",
    group: "BVKER / Distorted",
  },
  {
    id: "bvker/distorted/dist-diode-2",
    name: "Dist - Diode 2",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Distorted/Dist - Diode 2.wav",
    group: "BVKER / Distorted",
  },
  {
    id: "bvker/distorted/dist-downsample",
    name: "Dist - Downsample",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Distorted/Dist - Downsample.wav",
    group: "BVKER / Distorted",
  },
  {
    id: "bvker/distorted/dist-filter-drive",
    name: "Dist - Filter Drive",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Distorted/Dist - Filter Drive.wav",
    group: "BVKER / Distorted",
  },
  {
    id: "bvker/distorted/dist-hard-clipping-extra",
    name: "Dist - Hard Clipping Extra",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Distorted/Dist - Hard Clipping Extra.wav",
    group: "BVKER / Distorted",
  },
  {
    id: "bvker/distorted/dist-hard-clipping",
    name: "Dist - Hard Clipping",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Distorted/Dist - Hard Clipping.wav",
    group: "BVKER / Distorted",
  },
  {
    id: "bvker/distorted/dist-lin-fold",
    name: "Dist - Lin.Fold",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Distorted/Dist - Lin.Fold.wav",
    group: "BVKER / Distorted",
  },
  {
    id: "bvker/distorted/dist-rectify",
    name: "Dist - Rectify",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Distorted/Dist - Rectify.wav",
    group: "BVKER / Distorted",
  },
  {
    id: "bvker/distorted/dist-sin-fold",
    name: "Dist - Sin.Fold",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Distorted/Dist - Sin.Fold.wav",
    group: "BVKER / Distorted",
  },
  {
    id: "bvker/distorted/dist-sine-shaper",
    name: "Dist - Sine Shaper",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Distorted/Dist - Sine Shaper.wav",
    group: "BVKER / Distorted",
  },
  {
    id: "bvker/distorted/dist-soft-clipping",
    name: "Dist - Soft Clipping",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Distorted/Dist - Soft Clipping.wav",
    group: "BVKER / Distorted",
  },
  {
    id: "bvker/distorted/dist-stomp-box",
    name: "Dist - Stomp Box",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Distorted/Dist - Stomp Box.wav",
    group: "BVKER / Distorted",
  },
  {
    id: "bvker/distorted/dist-tape",
    name: "Dist - Tape",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Distorted/Dist - Tape.wav",
    group: "BVKER / Distorted",
  },
  {
    id: "bvker/distorted/dist-tube",
    name: "Dist - Tube",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Distorted/Dist - Tube.wav",
    group: "BVKER / Distorted",
  },
  {
    id: "bvker/distorted/dist-zero-square",
    name: "Dist - Zero Square",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Distorted/Dist - Zero Square.wav",
    group: "BVKER / Distorted",
  },
  {
    id: "bvker/fm/fm-01",
    name: "FM 01",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/FM/FM 01.wav",
    group: "BVKER / FM",
  },
  {
    id: "bvker/fm/fm-02",
    name: "FM 02",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/FM/FM 02.wav",
    group: "BVKER / FM",
  },
  {
    id: "bvker/fm/fm-03",
    name: "FM 03",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/FM/FM 03.wav",
    group: "BVKER / FM",
  },
  {
    id: "bvker/fm/fm-04",
    name: "FM 04",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/FM/FM 04.wav",
    group: "BVKER / FM",
  },
  {
    id: "bvker/fm/fm-05",
    name: "FM 05",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/FM/FM 05.wav",
    group: "BVKER / FM",
  },
  {
    id: "bvker/fm/fm-06",
    name: "FM 06",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/FM/FM 06.wav",
    group: "BVKER / FM",
  },
  {
    id: "bvker/fm/fm-07",
    name: "FM 07",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/FM/FM 07.wav",
    group: "BVKER / FM",
  },
  {
    id: "bvker/fm/fm-08",
    name: "FM 08",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/FM/FM 08.wav",
    group: "BVKER / FM",
  },
  {
    id: "bvker/fm/fm-09",
    name: "FM 09",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/FM/FM 09.wav",
    group: "BVKER / FM",
  },
  {
    id: "bvker/fm/fm-10",
    name: "FM 10",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/FM/FM 10.wav",
    group: "BVKER / FM",
  },
  {
    id: "bvker/fm/fm-11",
    name: "FM 11",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/FM/FM 11.wav",
    group: "BVKER / FM",
  },
  {
    id: "bvker/fm/fm-12",
    name: "FM 12",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/FM/FM 12.wav",
    group: "BVKER / FM",
  },
  {
    id: "bvker/fm/fm-13",
    name: "FM 13",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/FM/FM 13.wav",
    group: "BVKER / FM",
  },
  {
    id: "bvker/fm/fm-14",
    name: "FM 14",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/FM/FM 14.wav",
    group: "BVKER / FM",
  },
  {
    id: "bvker/fm/fm-15",
    name: "FM 15",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/FM/FM 15.wav",
    group: "BVKER / FM",
  },
  {
    id: "bvker/fm/fm-16",
    name: "FM 16",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/FM/FM 16.wav",
    group: "BVKER / FM",
  },
  {
    id: "bvker/fm/fm-17",
    name: "FM 17",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/FM/FM 17.wav",
    group: "BVKER / FM",
  },
  {
    id: "bvker/growl/growl-01",
    name: "Growl 01",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Growl/Growl 01.wav",
    group: "BVKER / Growl",
  },
  {
    id: "bvker/growl/growl-02",
    name: "Growl 02",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Growl/Growl 02.wav",
    group: "BVKER / Growl",
  },
  {
    id: "bvker/growl/growl-03",
    name: "Growl 03",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Growl/Growl 03.wav",
    group: "BVKER / Growl",
  },
  {
    id: "bvker/growl/growl-04",
    name: "Growl 04",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Growl/Growl 04.wav",
    group: "BVKER / Growl",
  },
  {
    id: "bvker/growl/growl-05",
    name: "Growl 05",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Growl/Growl 05.wav",
    group: "BVKER / Growl",
  },
  {
    id: "bvker/growl/growl-06",
    name: "Growl 06",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Growl/Growl 06.wav",
    group: "BVKER / Growl",
  },
  {
    id: "bvker/growl/growl-07",
    name: "Growl 07",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Growl/Growl 07.wav",
    group: "BVKER / Growl",
  },
  {
    id: "bvker/growl/growl-08",
    name: "Growl 08",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Growl/Growl 08.wav",
    group: "BVKER / Growl",
  },
  {
    id: "bvker/growl/growl-09",
    name: "Growl 09",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Growl/Growl 09.wav",
    group: "BVKER / Growl",
  },
  {
    id: "bvker/growl/growl-10",
    name: "Growl 10",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Growl/Growl 10.wav",
    group: "BVKER / Growl",
  },
  {
    id: "bvker/growl/growl-11",
    name: "Growl 11",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Growl/Growl 11.wav",
    group: "BVKER / Growl",
  },
  {
    id: "bvker/growl/growl-12",
    name: "Growl 12",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Growl/Growl 12.wav",
    group: "BVKER / Growl",
  },
  {
    id: "bvker/growl/growl-13",
    name: "Growl 13",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Growl/Growl 13.wav",
    group: "BVKER / Growl",
  },
  {
    id: "bvker/growl/growl-14",
    name: "Growl 14",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Growl/Growl 14.wav",
    group: "BVKER / Growl",
  },
  {
    id: "bvker/growl/growl-15",
    name: "Growl 15",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Growl/Growl 15.wav",
    group: "BVKER / Growl",
  },
  {
    id: "bvker/growl/growl-16",
    name: "Growl 16",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Growl/Growl 16.wav",
    group: "BVKER / Growl",
  },
  {
    id: "bvker/growl/growl-17",
    name: "Growl 17",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Growl/Growl 17.wav",
    group: "BVKER / Growl",
  },
  {
    id: "bvker/growl/growl-18",
    name: "Growl 18",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Growl/Growl 18.wav",
    group: "BVKER / Growl",
  },
  {
    id: "bvker/hyper/hyper-01",
    name: "Hyper 01",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Hyper/Hyper 01.wav",
    group: "BVKER / Hyper",
  },
  {
    id: "bvker/hyper/hyper-02",
    name: "Hyper 02",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Hyper/Hyper 02.wav",
    group: "BVKER / Hyper",
  },
  {
    id: "bvker/hyper/hyper-03",
    name: "Hyper 03",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Hyper/Hyper 03.wav",
    group: "BVKER / Hyper",
  },
  {
    id: "bvker/hyper/hyper-04",
    name: "Hyper 04",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Hyper/Hyper 04.wav",
    group: "BVKER / Hyper",
  },
  {
    id: "bvker/hyper/hyper-05",
    name: "Hyper 05",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Hyper/Hyper 05.wav",
    group: "BVKER / Hyper",
  },
  {
    id: "bvker/hyper/hyper-06",
    name: "Hyper 06",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Hyper/Hyper 06.wav",
    group: "BVKER / Hyper",
  },
  {
    id: "bvker/hyper/hyper-07",
    name: "Hyper 07",
    source: "file",
    pack: "bvker",
    path: "wavetables/BVKER - Custom Wavetables/Hyper/Hyper 07.wav",
    group: "BVKER / Hyper",
  },
];
